import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNrday65 } from './pages'

type TIdToPageMapWoofzNrday65 = Record<PageIdWoofzNrday65, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NRDAY_65: TIdToPageMapWoofzNrday65 = {
  [PageId.SUBSCRIPTIONS_NRDAY_65_N]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_65/pages/subscriptions/SubscriptionNrday65'
      ).then((m) => ({
        default: m.SubscriptionsNrday65,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_65/pages/subscriptions/SubscriptionNrday65'
      ),
  },
  [PageId.CHAT_UPSELL_NRDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_65/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_65/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NRDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_65/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_nrday/woofz_nrday_65/pages/upsell/Upsell'),
  },
  [PageIdWoofzNrday65.DOWNLOAD_NRDAY_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_65/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_65/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNrday65.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
